<template>
    <div class="body">
        <div class="popup1" v-if="flag">
            <div class="p_bg" @click.stop="flag = false"></div>
        </div>
        <div class="popup2" v-if="flag1">
            <div class="p_bg"></div>
        </div>
        <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div>
        <div class="content">
            <div class="c_left">
                <div class="cl_title">
                    创建智能体
                    <el-button type="primary" @click="btn_botCopy" v-if="assistantId">复制智能体</el-button>
                </div>
                <div class="cl_box">
                    <div class="cl_item">
                        <div class="cli_top">智能体图标</div>
                        <div class="cli_bottom">
                            <el-upload style="text-align: left;" :headers="myHeaders" :http-request="handleUploadImgForm"
                            :on-change="imgSaveToUrl" :show-file-list="false" action class="upload-demo"
                            accept="image/*">
                            <img class="lib_img" :src="webImg + icon" v-if="icon" />
                        </el-upload>
                        </div>
                    </div>
                    <div class="cl_item">
                        <div class="cli_top">语音通话</div>
                        <div class="cli_bottom">
                            <el-switch v-model="callOpen" active-text="开启" inactive-text="关闭"></el-switch>
                        </div>
                    </div>
                    <div class="cl_item">
                        <div class="cli_top">智能体名称</div>
                        <div class="cli_bottom">
                            <el-input v-model="name" type="text" placeholder="请输入内容" maxlength="10"
                                show-word-limit></el-input>
                        </div>
                    </div>
                    <div class="cl_item">
                        <div class="cli_top">开场语</div>
                        <div class="cli_bottom">
                            <el-input v-model="openingWords" type="text" placeholder="智能体打招呼的语言" maxlength="100"
                                show-word-limit></el-input>
                        </div>
                    </div>
                    <div class="cl_item">
                        <div class="cli_top">智能体介绍</div>
                        <div class="cli_bottom">
                            <el-input type="textarea" :rows="8" v-model="introduce" placeholder="请输入内容"
                                maxlength="500"></el-input>
                        </div>
                    </div>
                    <div class="cl_item" style="width: 100%;">
                        <div class="cli_top">
                            评价维度
                            <el-button size="mini" type="primary"
                                @click="wdDialogVisible = true, isAdd = true">新增</el-button>
                        </div>
                        <div class="cli_bottom" style="display: flex;align-items: center;flex-wrap: wrap;">
                            <div class="lib_item libi" v-for="(item, index) in wdList" :key="index"
                                @click="btn_weiduItem(item, index)">
                                {{ item.typeName }}
                                <img @click.stop="btn_wdDel(index)" src="../../assets/img/i85.png" />
                            </div>
                        </div>
                    </div>
                    <div class="cl_item" style="width: 100%;">
                        <div class="cli_top">
                            引用文件
                            <el-button size="mini" type="text" v-if="quoteFileList.length > 0"
                                @click="regeneratePromptFromQuoteFiles">重新生成提示词</el-button>
                        </div>
                        <div class="cli_bottom">
                            <div class="quote-upload-box">
                                <el-upload :headers="myHeaders" :http-request="handleUploadQuoteForm"
                                    :on-change="imgSaveToUrl" :show-file-list="false" action class="quote-uploader"
                                    multiple accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt">
                                    <div class="quote-upload-trigger">
                                        <img class="quote-upload-icon" src="../../assets/img/i7.png" />
                                        <div class="quote-upload-text">点击上传办公文档</div>
                                        <div class="quote-upload-tip">支持 Word、Excel、PPT、PDF、TXT，可多选</div>
                                    </div>
                                </el-upload>
                                <div class="quote-file-list" v-if="quoteFileList.length > 0">
                                    <div class="quote-file-item" v-for="(item, index) in quoteFileList" :key="index">
                                        <img class="qfi_icon" :src="settingFileIcon(item.resourceType, item.path)" />
                                        <div class="qfi_info">
                                            <div class="qfi_name line1_">{{ item.name || item.path }}</div>
                                            <div class="qfi_type">{{ getQuoteFileExt(item.name) }} 文档</div>
                                        </div>
                                        <img class="qfi_del" src="../../assets/img/i52.png"
                                            @click.stop="btn_delQuoteFile(index)" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="cl_btn" @click="flag = true">修改智能体</div> -->
            </div>
            <div class="c_center">
                <div class="cc_title">
                    <div class="cct_left">人设与回复逻辑</div>
                    <!-- <div class="cct_right" @click="evolve">
                        <img src="../../assets/img/i62.png" />
                        自动优化提示词
                    </div> -->
                </div>
                <!--  contenteditable="true" @input="updateContent" -->
                <textarea class="textareas" maxlength="50000" rows="30" placeholder="请输入" v-model="content"></textarea>
                <!-- <div class="cc_list">
                    <div class="ccl_item" v-for="(item, index) in cueWordList" :key="index">
                        <div class="cli_tit">##{{ item.labelName }}：</div>
                        <textarea maxlength="20000" rows="5" placeholder="请输入" v-model="item.content"></textarea>
                    </div>
                </div> -->
            </div>
            <div class="c_right">
                <div class="cr_title">预览与调试</div>
                <div class="chat">
                    <div class="ch_bottom" ref="scrollDiv">
                        <div class="chb_item" v-for="(item, index) in list" :key="index">
                            <div class="chb_left" v-if="!item.isMine">
                                <img class="hbl_left" :src="webImg + icon" />
                                <div class="hbl_right">
                                    <div class="blr_top">
                                        <div class="loading-container" v-if="isLoading && index == list.length - 1">
                                            <div class="dot"></div>
                                            <div class="dot"></div>
                                            <div class="dot"></div>
                                        </div>
                                        <div style="color: #757575 !important;border-left: 1px solid #c2c2c2;padding-left: 10px;"
                                            v-html="markedt(item.reasoning_content)" v-if="item.reasoning_content">
                                        </div>
                                        <!-- <div v-html="markedt(item.text)" v-if="item.text"></div> -->
                                        <div v-html="markedt(preprocessLaTeX(item.text))" v-if="item.text"></div>
                                    </div>
                                    <!-- <div class="blr_bottom" v-if="index > 0 && index == list.length - 1 && !stop">
                                        <div class="lrb_btn" @click="btn_reanswer">
                                            <img src="../../assets/img/i24.png" />
                                            再来一次
                                        </div>
                                        <div class="lrb_btn" @click="handleClipboard(item.text, $event)">
                                            <img src="../../assets/img/i22.png" />
                                            复制
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                            <div class="chb_right" v-if="item.isMine">
                                <div class="file" style="justify-content: flex-end;">
                                    <div class="f_item" v-for="(itemA, indexA) in item.fileList" :key="indexA">
                                        <img class="fi_icon" :src="settingFileIcon(itemA.resourceType, itemA.path)" />
                                        <div class="fi_text line1_">{{ itemA.name || itemA.path }}</div>
                                    </div>
                                </div>
                                <div class="hbr_bottom">
                                    <div class="hbr_text" v-html="item.text"
                                        v-if="item.text && item.text.trim() !== '' && item.text !== '<div></div>' && item.text !== '\n'">
                                    </div>
                                    <img class="hbr_tx" :src="webImg + userInfo.avatar" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex;align-items: center;width: 100%;" v-if="!isClose">
                        <!-- contenteditable="true" -->
                        <div class="o_bottom1">
                            <div class="file">
                                <div class="f_item" v-for="(item, index) in fileList" :key="index"
                                    @click="btn_delFile(item, index)">
                                    <img class="fi_icon" :src="settingFileIcon(item.resourceType, item.path)" />
                                    <div class="fi_text line1_">{{ item.name || item.path }}</div>
                                    <img class="fi_del" src="../../assets/img/i52.png" />
                                </div>
                            </div>
                            <textarea placeholder="请输入..." v-model="inputContent" @keyup="carriageReturn"></textarea>
                            <div class="ob_bottom1">
                                <!-- <div class="obb_left">R1深度思考</div> -->
                                <div class="obb_left">
                                    <img src="../../assets/img/i63.png" title="清除" @click="clearMsg" />
                                </div>
                                <div class="obb_right">
                                    <el-upload :headers="myHeaders" :http-request="handleUploadForm"
                                        :on-change="imgSaveToUrl" :show-file-list="false" action class="upload-demo"
                                        multiple accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx">
                                        <img class="bbr_1" src="../../assets/img/i7.png" />
                                    </el-upload>
                                    <el-upload :headers="myHeaders" :http-request="handleUploadImgForm1"
                                        :on-change="imgSaveToUrl" :show-file-list="false" action class="upload-demo"
                                        multiple accept="image/*">
                                        <img class="bbr_1" src="../../assets/img/i8.png" />
                                    </el-upload>
                                    <img class="bbr_2" src="../../assets/img/i9.png" @click="btn_send" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <el-button class="bo_1" type="danger" @click="btn_botDelete">删除</el-button>
            <el-button class="bo_1" type="primary" @click="submit">{{ isEdit ? '保存' : '创建' }}</el-button>
        </div>
        <div class="loading" v-if="flag1">
            <el-progress :text-inside="true" :stroke-width="24" :percentage="progress"></el-progress>
            <div>评价维度生成中，请稍候...</div>
        </div>
        <div class="addznt" v-if="flag">
            <div class="c_left">
                <div class="cl_title">编辑智能体</div>
                <!-- <div class="cl_tab" v-if="!assistantId">
                    <div class="clt_tab" @click="btn_courseType(1)">
                        <div class="ltt_top">课堂智能体</div>
                        <div class="ltt_bottom" v-if="courseType == 1"></div>
                    </div>
                    <div class="clt_tab" @click="btn_courseType(2)">
                        <div class="ltt_top">教研智能体</div>
                        <div class="ltt_bottom" v-if="courseType == 2"></div>
                    </div>
                </div> -->
                <div class="cl_box">
                    <div class="cl_top">
                        <div class="cli_top"><span>*</span>①智能体图标</div>
                        <div class="cli_bottom">
                            <el-upload style="text-align: left;" :headers="myHeaders"
                                :http-request="handleUploadImgForm" :on-change="imgSaveToUrl" :show-file-list="false"
                                action class="upload-demo" accept="image/*">
                                <div class="lib_add" v-if="!icon">
                                    <img src="../../assets/img/i54.png" />
                                    上传图标
                                </div>
                                <img class="lib_img" :src="webImg + icon" v-if="icon" />
                            </el-upload>
                        </div>
                    </div>
                    <div class="cl_top">
                        <div class="cli_top">语音通话</div>
                        <div class="cli_bottom">
                            <el-switch v-model="callOpen" active-text="开启" inactive-text="关闭"></el-switch>
                        </div>
                    </div>
                    <div class="cl_list">
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>②智能体名称</div>
                            <div class="cli_bottom">
                                <el-input v-model="name" type="text" placeholder="请输入内容" maxlength="10"
                                    show-word-limit></el-input>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>③智能体介绍</div>
                            <div class="cli_bottom">
                                <el-input v-model="introduce" type="text" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>④开场语</div>
                            <div class="cli_bottom">
                                <el-input v-model="openingWords" type="text" placeholder="智能体打招呼的语言" maxlength="50"
                                    show-word-limit></el-input>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>⑤学段</div>
                            <div class="cli_bottom">
                                <el-select v-model="sectionId" placeholder="请选择" @change="sectionChange">
                                    <el-option v-for="item in sectionArr" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>⑥学科</div>
                            <div class="cli_bottom">
                                <el-select v-model="subjectId" placeholder="请选择" @change="subjectChange">
                                    <el-option v-for="item in subjectArr" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>⑦目标任务</div>
                            <div class="cli_bottom">
                                <el-select v-model="tarId" placeholder="请选择" @change="tarChange">
                                    <el-option v-for="item in tarArr" :key="item.id" :label="item.targetName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>⑧版本</div>
                            <div class="cli_bottom">
                                <el-select v-model="versionId" placeholder="请选择" @change="versionChange">
                                    <el-option v-for="item in versionArr" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>⑨单元</div>
                            <div class="cli_bottom">
                                <el-select v-model="moduleId" placeholder="请选择" @change="moduleChange">
                                    <el-option v-for="item in moduleArr" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>⑩章节</div>
                            <div class="cli_bottom">
                                <el-select v-model="chapterId" placeholder="请选择" @change="chapterChange">
                                    <el-option v-for="item in chapterArr" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cl_item" style="width: 100%;">
                            <div class="cli_top"><span>*</span>⑪评价维度</div>
                            <div class="cli_bottom" style="display: flex;align-items: center;flex-wrap: wrap;">
                                <div class="lib_item" :class="item.select ? 'libi' : ''" v-for="(item, index) in wdList"
                                    :key="index" @click="btn_wdItem(item, index)">{{ item.typeName }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="next" @click="flag = false">完成</div>
            </div>
        </div>
        <el-dialog :close-on-press-escape="false" :show-close="false" :close-on-click-modal="false"
            :title="isAdd ? '新增维度' : '编辑维度'" :visible.sync="wdDialogVisible" width="30%">
            <div style="margin-bottom: 10px;">归属核心维度</div>
            <el-select style="margin-bottom: 10px;" v-model="wdOptId" placeholder="请选择" @change="wdOptChange">
                <el-option v-for="item in wdOption" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
            </el-select>
            <div style="margin-bottom: 10px;">细化评价维度</div>
            <el-input style="margin-bottom: 10px;" v-model="currentWdItem.typeName" type="text" placeholder="请输入"
                maxlength="50"></el-input>
            <div style="margin-bottom: 10px;">细化维度定义</div>
            <el-input style="margin-bottom: 10px;" v-model="currentWdItem.typeExplain" type="text" placeholder="请输入"
                maxlength="500"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="btn_wdClose">取 消</el-button>
                <el-button type="primary" @click="btn_wdEditConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import { fetchEventSource } from '@microsoft/fetch-event-source';
import MarkdownIt from 'markdown-it'
import Clipboard from 'clipboard'
// import mk from 'markdown-it-katex';
import '@/assets/katex/dist/katex.min.css';
// import markdownItKatex from 'markdown-it-katex';
import markdownItKatex from '@iktakahiro/markdown-it-katex';

import { botCopy, botDelete, botCreate, botList, ossToken, createSession, helperMsgDetailList, botInfo, botUpdate, classroomTestInfo, promptEvolve, evaluateTypeOption, evaluateTypeAdd, teacherTerminalTestInfo, sectionSubject, targetOption, childrenList, knowledgePointsOption, defaultPrompt, defaultEvaluate, topEvaluateTypeOption } from '@/apis/index'

const markdownRender = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    breaks: true
});
markdownRender.use(markdownItKatex);
export default {
    data() {
        return {
            flag: false,
            flag1: false,
            myHeaders: { "X-Token": ossToken() },
            content: '',
            cueWordList: [
                { labelName: '角色', content: '' },
                { labelName: '目标', content: '' },
                { labelName: '技能', content: '' },
                { labelName: '工作流', content: '' },
                { labelName: '输出格式', content: 'markdown格式，如果有数学公式，必须用$符号拼接起来' },
                { labelName: '限制', content: '' }
            ],
            coreTasks: '',
            description: '',
            icon: '',
            name: '',
            openingWords: '',
            quoteFileList: [],
            courseType: 1,
            sessionId: '',
            templateList: [],
            prompts: '',
            stop: false,
            isLoading: false,
            controller: null,
            inputContent: '',
            eventSource: null,
            myHeaders: { "X-Token": ossToken() },
            hover: false,
            sessionId: '', //会话ID
            reAnswerFlag: false,
            fileList: [],
            assistantId: '',
            assistantItem: {},
            list: [],
            userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
            info: {},
            isEdit: false,
            botId: '',
            helperId: '',
            wdList: [],//维度列表
            evaluateTypeId: [],//记录已选择维度的ID
            isClose: false,
            sectionId: '',
            subjectId: '',
            sectionArr: [],
            subjectArr: [],
            tarArr: [],
            tarId: '',
            Yprompt: '',
            knowledgePointId: '',
            knowledgePointArr: [],
            wdDialogVisible: false,
            currentWdItem: {
                supId: '',
                supName: '',
                typeName: '',
                typeExplain: ''
            },
            wdOption: [],
            wdOptId: '',
            isAdd: false,
            progress: 0,
            introduce: '',
            test: '大于（例如：$5 > 5$ ）',
            callOpen: false,
            callBotId:''
        }
    },
    created() {
        if (this.$route.query.obj) {
            this.obj = JSON.parse(this.$route.query.obj)
            console.log(this.obj, 'obj');
            var { introduce, courseType, description, icon, name, openingWords, sectionId, subjectId, classTargetId, versionId, moduleId, chapterId, knowledgePointId, quoteFileList } = this.obj
            this.courseType = courseType
            // this.description = description
            this.icon = icon
            this.name = name
            this.openingWords = openingWords
            this.introduce = description
            // this.getEvaluateTypeOption(() => {
            //     const idSet = new Set(wdList);
            //     this.wdList = this.wdList.map(item => ({
            //         ...item,
            //         select: idSet.has(item.id) ? true : item.select || false
            //     }));
            //     this.evaluateTypeId = this.wdList.filter(item => item.select === true).map(item => item.id)
            // })
            this.sectionId = sectionId
            this.subjectId = subjectId
            this.tarId = classTargetId
            this.knowledgePointId = knowledgePointId || ''
            this.quoteFileList = quoteFileList || []
            this.content = localStorage.getItem('prompt')
        }
        if (this.$route.query.id) {
            this.assistantId = this.$route.query.id
            this.getbotInfo()
        }
    },
    mounted() {
        this.getTopEvaluateTypeOption()
        this.getSectionSubject()
    },
    destroyed() {
        this.$loading().close()
    },
    methods: {
        btn_botCopy() {
            botCopy(this.assistantId).then(res => {
                console.log(res, 'botCopy');
                this.$message.success('复制成功')
            })
        },
        btn_botDelete() {
            this.$confirm('是否确定删除该智能体?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                botDelete(this.assistantId).then(res => {
                    console.log(res, 'botDelete');
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    setTimeout(() => {
                        this.$router.go(-1)
                    }, 500);
                })
            })
        },
        btn_wdDel(index) {
            this.$confirm('是否确定删除该维度?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.wdList.splice(index, 1)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
            });
        },
        btn_wdClose() {
            this.wdDialogVisible = false
            this.isAdd = false
            setTimeout(() => {
                this.wdOptId = ''
                this.currentWdItem = {
                    supId: '',
                    supName: '',
                    typeName: '',
                    typeExplain: ''
                }
            }, 500);
        },
        btn_wdEditConfirm() {
            this.wdDialogVisible = false
            if (!this.wdOptId) {
                return this.$message.error('请选择归属核心维度')
            }
            if (!this.isAdd) {
                var index = this.wdList.findIndex(item => item.supId == this.wdOptId)
                console.log(index, 'idex');

                this.wdList[index].typeName = this.currentWdItem.typeName
                this.wdList[index].typeExplain = this.currentWdItem.typeExplain
                setTimeout(() => {
                    this.wdOptId = ''
                    this.currentWdItem = {
                        supId: '',
                        supName: '',
                        typeName: '',
                        typeExplain: ''
                    }
                }, 500);
            } else {
                this.isAdd = false
                this.wdList.push({
                    "supId": this.wdOptId,
                    "supName": this.currentWdItem.supName,
                    "typeName": this.currentWdItem.typeName,
                    "typeExplain": this.currentWdItem.typeExplain
                })
                setTimeout(() => {
                    this.wdOptId = ''
                    this.currentWdItem = {
                        supId: '',
                        supName: '',
                        typeName: '',
                        typeExplain: ''
                    }
                }, 500);
            }
        },
        wdOptChange(e) {
            console.log(e, 'eee', this.wdList.find(item => item.supId == e));
            this.currentWdItem.supName = this.wdList.find(item => item.supId == e).supName
        },
        getTopEvaluateTypeOption() {
            topEvaluateTypeOption(this.courseType).then(res => {
                console.log(res, 'wdOption');
                this.wdOption = res.data
            })
        },
        btn_weiduItem(item, index) {
            console.log(item, 'item');
            this.currentWdItem = item
            this.wdOptId = item.supId
            this.wdDialogVisible = true
        },
        startProgress(duration, onUpdate) {
            const startTime = Date.now();
            const endTime = startTime + duration;
            const timer = setInterval(() => {
                const now = Date.now();
                let progress = ((now - startTime) / duration) * 100;

                if (progress >= 100) {
                    progress = 100;
                    clearInterval(timer);
                    if (onUpdate) onUpdate(progress);
                    // if (onComplete) onComplete();
                } else {
                    if (onUpdate) onUpdate(progress);
                }
            }, 100); // 每100毫秒更新一次进度
        },
        // 获取默认维度
        getDefaultEvaluate() {
            console.log(this.sectionArr, 'sectionArr', this.subjectArr, 'ssss', this.knowledgePointArr);
            // && this.knowledgePointArr.length > 0
            if (this.sectionArr.length > 0 && this.subjectArr.length > 0) {
                this.flag1 = true
                this.startProgress(120000, progress => {
                    console.log(progress, 'progress');
                    this.progress = parseInt(progress)
                })
                defaultEvaluate({
                    courseType: this.courseType,
                    description: this.introduce,
                    name: this.name,
                    sectionName: this.sectionArr.find(item => item.id == this.sectionId).name,
                    subjectName: this.subjectArr.find(item => item.id == this.subjectId).name,
                    quoteFiles: this.getQuoteFilesValue(),
                    // targetName: this.tarArr.find(item => item.id == this.tarId).targetName,
                    // knowledgePointsName: this.knowledgePointId?this.knowledgePointArr.find(item => item.id == this.knowledgePointId).knowledgePointsName:''
                }).then(res => {
                    console.log(res, 'defaultEvaluate');
                    this.wdList = res.data
                    this.evaluateTypeId = this.wdList.map(item => item.supId)
                }).finally(() => {
                    this.flag1 = false
                })
            }

        },
        // 知识点
        getKnowledgePointsOption(fun) {
            knowledgePointsOption(this.subjectId).then(res => {
                console.log(res, 'knowledgePointsOption');
                this.knowledgePointArr = res.data
                fun(res.data)
            })
        },
        replacePlaceholders(str) {
            if (this.subjectArr.length > 0 && this.versionArr.length > 0 && this.moduleArr.length > 0 && this.chapterArr.length > 0) {
                var values = {
                    学段: this.sectionArr.find(item => item.id == this.sectionId).name,
                    学科: this.subjectArr.find(item => item.id == this.subjectId).name,
                    版本: this.versionArr.find(item => item.id == this.versionId).name,
                    单元: this.moduleArr.find(item => item.id == this.moduleId).name,
                    章节: this.chapterArr.find(item => item.id == this.chapterId).name
                }
                return str.replace(/\{([^}]+)\}/g, (match, key) => {
                    // key 是大括号内的内容，比如 "版本"
                    if (values.hasOwnProperty(key)) {
                        return values[key]; // 替换成对应的值
                    }
                    return match; // 如果没有对应值，保持原样
                });
            }
        },
        tarChange(e) {
            // this.content = this.replacePlaceholders(this.tarArr.find(item => item.id == e).prompt)
        },
        //获取目标数据
        getTargetOption(fun) {
            targetOption(this.subjectId).then(res => {
                console.log(res, 'targetArr');
                this.tarArr = res.data
                fun()
            })
        },
        // 学科变化事件
        subjectChange(e) {
            this.tarId = ''
            this.tarArr = []
            this.versionId = ''
            this.versionArr = []
            this.moduleId = ''
            this.moduleArr = []
            this.chapterId = ''
            this.chapterArr = []
            this.getTargetOption()
            this.getVersionOpt(e)
        },
        // 学段变化事件
        sectionChange(e) {
            this.subjectId = ''
            this.subjectArr = []
            this.tarId = ''
            this.tarArr = []
            this.versionId = ''
            this.versionArr = []
            this.moduleId = ''
            this.moduleArr = []
            this.chapterId = ''
            this.chapterArr = []
            console.log(e, 'e', this.sectionArr.find(item => item.id == e));
            this.subjectArr = this.sectionArr.find(item => item.id == e).subjectList
        },
        getSectionSubject() {
            sectionSubject(2).then(res => {
                console.log(res, 'sectionSubject');
                this.sectionArr = res.data;
                this.subjectArr = this.sectionArr.find(item => item.id == this.sectionId).subjectList;
                this.getKnowledgePointsOption(() => {
                    this.getTargetOption(() => {
                        this.$nextTick(() => {
                            if (this.$route.query.obj) {

                                this.getDefaultEvaluate()
                            }
                        })
                    })
                })
            });
        },
        btn_wdItem(item, index) {
            item.select = !item.select
            this.evaluateTypeId = this.wdList.filter(item => item.select === true).map(item => item.id)
        },
        btn_courseType(courseType) {
            this.courseType = courseType
            this.evaluateTypeId = []
            // this.getEvaluateTypeOption()
        },
        // 新建维度
        openCreateWd() {
            this.$prompt('请输入评价维度', '新建维度', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                // inputErrorMessage: '邮箱格式不正确'
            }).then(({ value }) => {
                evaluateTypeAdd({
                    courseType: this.courseType,
                    typeName: value
                }).then(res => {
                    console.log(res, 'evaluateTypeAdd');
                    // this.getEvaluateTypeOption()
                })
            })
        },
        // 获取维度数据
        getEvaluateTypeOption(fun = () => { }) {
            evaluateTypeOption(this.courseType).then(res => {
                console.log(res, 'evaluateTypeOption');
                res.data.forEach(e => { e.select = false })
                this.wdList = res.data
                fun()
            })
        },
        clearMsg() {
            this.list.splice(1)
        },
        btn_delFile(item, index) {
            this.fileList.splice(index, 1);
            this.$forceUpdate();
        },
        btn_delQuoteFile(index) {
            this.quoteFileList.splice(index, 1);
            this.$forceUpdate();
        },
        parseQuoteFiles(quoteFiles) {
            if (!quoteFiles) {
                return [];
            }
            return quoteFiles.split(',').filter(path => path && path.trim()).map(path => {
                const trimmedPath = path.trim();
                return {
                    path: trimmedPath,
                    resourceType: 3,
                    name: trimmedPath.split('/').pop()
                };
            });
        },
        getQuoteFilesValue() {
            return this.quoteFileList.map(item => item.path).join(',');
        },
        regeneratePromptFromQuoteFiles() {
            if (!this.sectionId || !this.subjectId) {
                return this.$message.warning('请先选择学段和学科');
            }
            if (this.quoteFileList.length === 0) {
                return this.$message.warning('请先上传引用文件');
            }
            let loading = this.$loading({
                lock: true,
                text: "正在根据引用文件重新生成提示词...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            defaultPrompt({
                courseType: this.courseType,
                description: this.introduce,
                name: this.name,
                sectionName: this.sectionArr.find(item => item.id == this.sectionId).name,
                subjectName: this.subjectArr.find(item => item.id == this.subjectId).name,
                quoteFiles: this.getQuoteFilesValue(),
            }).then(res => {
                this.content = res.data;
                localStorage.setItem('prompt', res.data);
                this.$message.success('提示词已根据引用文件重新生成');
            }).finally(() => {
                loading.close();
            });
        },
        getQuoteFileExt(name) {
            if (!name || !name.includes('.')) {
                return '办公';
            }
            return name.split('.').pop().toUpperCase();
        },
        getbotInfo() {
            botInfo(this.assistantId).then((res) => {
                console.log(res, 'botInfo');
                var {
                    botId,
                    coreTasks,
                    description,
                    icon,
                    id,
                    name,
                    openingWords,
                    quoteFiles,
                    prompt,
                    evaluateTypeId,
                    courseType,
                    sectionId,
                    subjectId,
                    classTargetId,
                    knowledgePointsId,
                    introduce,
                    callBotId
                } = res.data
                this.sectionId = sectionId
                this.subjectId = subjectId
                this.tarId = classTargetId
                this.callBotId = callBotId
                this.knowledgePointId = knowledgePointsId
                this.courseType = courseType || null
                this.wdList = res.data.techClassEvaluateTypeList
                if (evaluateTypeId) {
                    this.evaluateTypeId = evaluateTypeId.split(',').map(Number) || []
                }
                this.coreTasks = coreTasks || ''
                // this.cueWordList = cueWordList || []
                this.description = description || ''
                this.introduce = introduce
                this.icon = icon || ''
                this.name = name || ''
                this.openingWords = openingWords || ''
                this.quoteFileList = this.parseQuoteFiles(quoteFiles)
                this.assistantItem = res.data
                this.botId = botId
                this.isEdit = true
                this.content = prompt
                this.callOpen = !!callBotId

                // this.getEvaluateTypeOption(() => {
                //     const idSet = new Set(this.evaluateTypeId);
                //     this.wdList = this.wdList.map(item => ({
                //         ...item,
                //         select: idSet.has(item.id) ? true : item.select || false
                //     }));
                //     this.evaluateTypeId = this.wdList.filter(item => item.select === true).map(item => item.id)
                // })
                this.getCreateSession()

            })
        },
        getHelperMsgDetailList() {
            helperMsgDetailList(this.sessionId).then((res) => {
                console.log(res, 'helperMsgDetailList');
                if (res.data.techHelperMsgs.length > 0) {
                    res.data.techHelperMsgs.forEach((e) => {
                        this.list.push({
                            id: e.id,
                            text: e.content,
                            isMine: e.senderType == 1,
                            time: e.time
                        });
                    });
                }
            });
        },
        arrayToRichText(array) {
            let html = '<div>';
            for (let i = 0; i < array.length; i++) {
                if (!array[i].attrName) {
                    html += `<div>${array[i].title + ':  ' + (array[i].defaultVal || '')}</div>`;
                } else if (array[i].attrName) {
                    html += `<div>${array[i].attrName + ':  ' + (array[i].selectName || '')}</div>`;
                }
            }
            html += '</div>';
            return html;
        },
        textReplace() {
            // 创建一个新的 Map
            const dataMap = new Map();
            // 使用 forEach 方法填充 Map
            this.templateList.forEach(obj => {
                if (obj.defaultVal) {
                    dataMap.set(obj.title, obj.defaultVal);
                }
            });
            console.log(dataMap, 'dataMap');
            // 替换字符串中的占位符
            this.prompts = this.prompts.replace(/{(.*?)}/g, (match, key) => {
                console.log(dataMap.get(key) || match, 'ssssss');
                return dataMap.get(key) || ''; // 如果找不到对应的值，则保留原始占位符
            });
            console.log(this.prompts, 'prompts');
        },
        btn_reanswer() {
            this.reAnswerFlag = true
            this.btn_send()
        },
        btn_send() {
            if (!this.assistantId) {
                return this.$message.warning('请先创建智能体')
            }
            // 只有当eventSource不存在时才创建新的EventSource连接
            if (!this.stop) {
                this.controller = new AbortController();
                const { signal } = this.controller;
                var msg = ''
                if (this.inputContent.trim() == '' && !this.reAnswerFlag && this.fileList.length == 0) {
                    return this.$message.warning('请先输入内容')
                }
                if (!this.inputContent) {
                    this.textReplace()
                    msg = this.arrayToRichText(this.templateList)
                } else {
                    msg = this.inputContent
                }
                console.log(msg, 'msg');
                var flist = []
                if (this.fileList.length > 0) {
                    // flist = this.fileList.map(e => e.taskId)
                    flist = this.fileList.map(e => e.path)
                }
                // const fileText = this.fileList.length > 0 ? `[等${this.fileList.length}条资源文件]` : '';
                // const result = `${msg} ${fileText}`;
                if (!this.reAnswerFlag) {
                    this.list.push({ text: msg, isMine: true, fileList: [...this.fileList], time: this.getDateTime2(new Date().getTime()) });
                }
                this.list.push({ text: "", isMine: false, time: this.getDateTime2(new Date().getTime()), reasoning_content: '', });
                this.handleScrollBottom()
                console.log(this.list, 'list');

                var this_ = this
                this.stop = true
                this.isLoading = true
                // 创建新的EventSource连接
                var url = process.env.VUE_APP_BASE_API + `presetHelper/completions`
                this.eventSource = fetchEventSource(url, {
                    method: 'POST',
                    headers: {
                        "Content-Type": 'application/json',
                        "Accept": 'text/event-stream',
                        "token": localStorage.getItem('token')
                    },
                    body: JSON.stringify({
                        sessionId: this.sessionId,
                        messages: this.inputContent,
                        prompts: !this.inputContent ? this.prompts : '',
                        filePathList: flist,
                        reAnswerFlag: this.reAnswerFlag,
                        courseType: this.courseType

                    }),
                    signal: signal,
                    openWhenHidden: true,
                    onmessage(event) {
                        console.info(event.data);
                        if (event.data && this_.isLoading) {
                            this_.isLoading = false
                        }
                        this_.reAnswerFlag = false
                        let dataJ = JSON.parse(event.data)
                        if (dataJ.error == 0) {
                            this_.isClose = true;
                            this_.close()
                        }
                        // if (dataJ.reasoning_content) {
                        //     this_.list[this_.list.length - 1].reasoning_content += dataJ.reasoning_content;
                        //     console.log(this_.list[this_.list.length - 1].reasoning_content, 'sss');
                        // }
                        this_.list[this_.list.length - 1].text += dataJ.content;
                        this_.$forceUpdate()
                        this_.handleScrollBottom()
                    },
                    onclose(ee) {
                        // 关闭流
                        this_.close()
                    },
                    onerror(error) {
                        console.info(error);
                        //返回流报错
                    }
                });
                console.log(this.eventSource, 'eventSource');
                this.inputContent = ''
                this.fileList = []
            }
        },
        close() {
            this.controller.abort();
            this.controller = null
            this.stop = false
            this.isLoading = false
            // this.eventSource = null; // 重置eventSource变量，允许重建连接
            // this.eventSource.close(); // 关闭出错的连接
        },
        // 滚动到底部
        handleScrollBottom() {
            this.$nextTick(() => {
                let scrollElem = this.$refs.scrollDiv;
                scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
            });
        },
        handleClipboard(text, event) {
            console.log(event);
            const clipboard = new Clipboard(event.target, {
                text: () => text
            })
            clipboard.on('success', () => {
                this.clipboardSuccess()
                clipboard.destroy()
            })
            clipboard.on('error', () => {
                this.clipboardError()
                clipboard.destroy()
            })
            clipboard.onClick(event)
        },
        clipboardSuccess() {
            this.$message.success('复制成功')
        },
        clipboardError() {
            this.$message.error('复制失败')
        },

        carriageReturn(event) {
            let e = window.event || arguments[0];
            if (!e.ctrlKey && e.keyCode == 13) {
                e.returnValue = false;
                this.btn_send();
                return false;
            }
        },
        getclassroomTestInfo() {
            if (this.courseType == 1) {
                classroomTestInfo(this.assistantId, this.sessionId).then(res => {
                    console.log(res, 'classroomTestInfo');
                    if (res.data && res.data.type == 4) {
                        this.helperId = res.data.id
                    }
                    this.getHelperMsgDetailList();
                })
            } else {
                teacherTerminalTestInfo(this.assistantId, this.sessionId).then(res => {
                    console.log(res, 'teacherTerminalTestInfo');
                    if (res.data && res.data.type == 4) {
                        this.helperId = res.data.id
                    }
                    this.getHelperMsgDetailList();
                })
            }
        },
        getCreateSession() {
            createSession(this.assistantId).then(res => {
                console.log(res, 'createSession');
                this.sessionId = res.data
                this.getclassroomTestInfo()
            })
        },
        markedt(markdown) {
            if (markdown) {
                return markdownRender.render(markdown);
            }
            return '';
        },
        handleUploadQuoteForm(param) {
            const allowedExt = ['doc', 'docx', 'pdf', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'];
            const fileName = param.file.name || '';
            const ext = fileName.includes('.') ? fileName.split('.').pop().toLowerCase() : '';
            if (!allowedExt.includes(ext)) {
                return this.$message.warning('仅支持上传常见办公文档（Word、Excel、PPT、PDF、TXT）');
            }
            this.uploadFileToOss(param, (fileItem) => {
                this.quoteFileList.push(fileItem);
            });
        },
        uploadFileToOss(param, onSuccess) {
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                ossData.append("file", param.file);
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: ossRes.host,
                    data: ossData
                }).then((res2) => {
                    onSuccess({
                        path: res2.data.url,
                        resourceType: 3,
                        select: 1,
                        name: param.file.name
                    });
                    loading.close();
                }).catch(() => {
                    loading.close();
                    this.$message.error('上传失败，请重试');
                });
            }).catch(() => {
                loading.close();
                this.$message.error('上传失败，请重试');
            });
        },
        // 上传
        handleUploadForm(param) {
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.fileList.push({
                        path: res2.data.url,
                        resourceType: 3,
                        select: 1,
                        name: param.file.name
                    })
                    loading.close();
                })
            })
        },
        handleUploadImgForm1(param) {
            console.log(param, 'imgup');
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.fileList.push({
                        path: res2.data.url,
                        resourceType: 2,
                        select: 1,
                        name: param.file.name
                    })
                    loading.close();
                    console.log(this.fileList, 'fileList');
                })
            })
        },
        handleUploadImgForm(param) {
            console.log(param, 'imgup');
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.icon = res2.data.url
                    console.log(this.icon, 'icon');
                    loading.close();
                })
            })
        },
        // 选取图片后自动回调，里面可以获取到文件
        imgSaveToUrl(event) {
            console.log(event, 'eventOnchange');
        },
        submit() {
            if (this.icon.trim() == '') {
                return this.$message.warning('请先上传智能体图标')
            }
            if (this.name.trim() == '') {
                return this.$message.warning('请先输入智能体名称')
            }
            // if (this.description.trim() == '') {
            //     return this.$message.warning('请先输入智能体功能介绍')
            // }
            if (!this.sectionId) {
                return this.$message.warning('请选择学段')
            }
            if (!this.subjectId) {
                return this.$message.warning('请选择学科')
            }
            // if (!this.tarId) {
            //     return this.$message.warning('请选择目标任务')
            // }
            this.throttle(() => {
                let loading = this.$loading({
                    lock: true,
                    text: "正在提交，请稍候...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                if (!this.isEdit) {
                    botCreate({
                        coreTasks: this.coreTasks,
                        prompt: this.content,
                        introduce: this.introduce,
                        // description: this.description,
                        icon: this.icon,
                        name: this.name,
                        openingWords: this.openingWords,
                        quoteFiles: this.getQuoteFilesValue(),
                        // evaluateTypeId: this.evaluateTypeId.join(','),
                        courseType: this.courseType,
                        sectionId: this.sectionId,
                        subjectId: this.subjectId,
                        // classTargetId: this.tarId,
                        techClassEvaluateTypeList: this.wdList,
                        knowledgePointsId: this.knowledgePointId,
                        callOpen: this.callOpen
                    }).then(res => {
                        console.log(res, 'res');
                        this.assistantId = res.data
                        this.$message.success('创建成功')
                        this.assistantId = res.data
                        this.getbotInfo()
                        localStorage.removeItem('prompt')
                    }).finally(() => {
                        loading.close();
                    })
                } else {
                    botUpdate({
                        id: this.assistantId,
                        botId: this.botId,
                        coreTasks: this.coreTasks,
                        prompt: this.content,
                        // cueWordList: this.cueWordList,
                        introduce: this.introduce,
                        // description: this.description,
                        icon: this.icon,
                        name: this.name,
                        openingWords: this.openingWords,
                        quoteFiles: this.getQuoteFilesValue(),
                        // evaluateTypeId: this.evaluateTypeId.join(','),
                        courseType: this.courseType,
                        sectionId: this.sectionId,
                        subjectId: this.subjectId,
                        // classTargetId: this.tarId,
                        techClassEvaluateTypeList: this.wdList,
                        knowledgePointsId: this.knowledgePointId,
                        callOpen: this.callOpen
                    }).then(res => {
                        console.log(res, 'res');
                        this.$message.success('编辑成功')
                        this.getCreateSession()
                        localStorage.removeItem('prompt')
                    }).finally(() => {
                        this.list = []
                        loading.close();
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep {
    .el-progress-bar__innerText {
        color: #000000 !important;
    }

    .el-select {
        width: 100% !important;
    }

    .upload-demo {
        text-align: right;
    }

    ol,
    ul {
        padding-left: 2em;

    }

    li {
        list-style: decimal !important;
    }

    code {
        /*元素内的空白保留，并允许换行*/
        white-space: pre-wrap !important;
        /*是否允许在单词内断句*/
        word-wrap: break-word !important;
        font-family: PingFang;
    }

    .katex-html {
        // display: none !important;
    }

    annotation {
        display: none !important;
    }

    table {
        border-collapse: collapse;
        /* 确保表格的边框线会合并为单一的线条 */
        border: 1px solid black;
        /* 设置表格的边框 */
    }

    td,
    th {
        border: 1px solid black;
        /* 设置单元格的边框 */
    }

    h1 {
        font-size: 16px;
        font-weight: bold;
    }

    h2 {
        font-size: 16px;
        font-weight: bold;
    }

    h3 {
        font-size: 16px;
        font-weight: bold;
    }

    p {
        font-size: 16px;
    }

    li {
        font-size: 16px;
    }
}

.quote-upload-box {
    width: 100%;
}

.quote-uploader {
    width: 100%;

    ::v-deep .el-upload {
        width: 100%;
    }
}

.quote-upload-trigger {
    width: 100%;
    min-height: 108px;
    border: 1px dashed #C5D9F2;
    border-radius: 10px;
    background: linear-gradient(180deg, #FAFCFF 0%, #F4F8FF 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 18px 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;

    &:hover {
        border-color: #2992FF;
        background: #F2F8FF;
        box-shadow: 0 4px 12px rgba(41, 146, 255, 0.08);
    }

    .quote-upload-icon {
        width: 28px;
        height: 28px;
        margin-bottom: 10px;
    }

    .quote-upload-text {
        font-size: 14px;
        font-weight: 600;
        color: #2992FF;
        line-height: 20px;
    }

    .quote-upload-tip {
        margin-top: 6px;
        font-size: 12px;
        color: #9AA5B5;
        line-height: 18px;
        text-align: center;
    }
}

.quote-file-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 14px;
}

.quote-file-item {
    width: calc(50% - 6px);
    min-width: 0;
    height: 58px;
    border-radius: 10px;
    background: #F7F9FC;
    border: 1px solid #E8EEF5;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    transition: all 0.2s ease;

    &:hover {
        border-color: #C5D9F2;
        background: #F3F8FF;
    }

    .qfi_icon {
        width: 32px;
        height: 32px;
        flex-shrink: 0;
    }

    .qfi_info {
        flex: 1;
        min-width: 0;
        margin: 0 10px;
    }

    .qfi_name {
        font-size: 13px;
        font-weight: 600;
        color: #2C2C2C;
        line-height: 18px;
    }

    .qfi_type {
        margin-top: 2px;
        font-size: 11px;
        color: #9AA5B5;
        line-height: 16px;
    }

    .qfi_del {
        width: 18px;
        height: 18px;
        cursor: pointer;
        flex-shrink: 0;
        opacity: 0.55;
        transition: opacity 0.2s ease;

        &:hover {
            opacity: 1;
        }
    }
}

.file {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .f_item:nth-child(3n) {
        margin-right: 0 !important;
    }

    .f_item {
        width: 262px;
        height: 55px;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 8px;
        display: flex;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.03);
        margin-right: 15px;
        margin-bottom: 15px;

        .fi_icon {
            width: 30px;
            height: 30px;
        }

        .fi_text {
            color: #000000;
            font-size: 14px;
            font-weight: 500;
            flex: 1;
            margin: 0 10px;
        }

        .fi_del {
            width: 20px;
            height: 20px;
            cursor: pointer;
        }
    }
}

.body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .popup1 {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 2;

        .p_bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }
    }

    .popup2 {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 2;

        .p_bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }
    }

    .loading {
        color: rgb(64, 158, 255);
        z-index: 3;
        position: absolute;
        top: 45%;

        div {
            font-size: 16px;
            margin-top: 20px;
        }
    }

    .addznt {
        width: 820px;
        // height: 500px;
        background: #FFFFFF;
        border-radius: 16px;
        position: absolute;
        top: 370px;
        /* 距离顶部 50% */
        left: 50%;
        /* 距离左侧 50% */
        transform: translate(-50%, -50%);
        box-sizing: border-box;
        padding: 35px 50px;
        z-index: 3;

        .c_left {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .cl_title {
                width: 100%;
                font-weight: bold;
                font-size: 19px;
                color: #252525;
                margin-bottom: 20px;

            }

            .cl_tab {
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .clt_tab {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-right: 50px;
                    cursor: pointer;

                    .ltt_top {
                        font-weight: 500;
                        font-size: 16px;
                        color: #000000;
                    }

                    .ltt_bottom {
                        width: 46px;
                        height: 2px;
                        background: #2992FF;
                        border-radius: 4px 4px 4px 4px;
                        margin-top: 10px;
                    }
                }
            }

            .cl_box {
                width: 100%;
                flex: 1;
                height: 0;

                // overflow-y: scroll;
                .cl_top {
                    width: 100%;
                    margin-bottom: 20px;
                    display: flex;
                    align-items: center;

                    .cli_top {
                        width: 85px;
                        font-weight: bold;
                        font-size: 12px;
                        color: #252525;

                        span {
                            font-weight: 500;
                            font-size: 16px;
                            color: #FF0000;
                        }
                    }

                    .cli_bottom {

                        // width: 100%;
                        // width: 255px;
                        .lib_btn {
                            width: 91px;
                            height: 37px;
                            border-radius: 8px 8px 8px 8px;
                            border: 1px solid #399AFF;
                            font-weight: bold;
                            font-size: 16px;
                            color: #2992FF;
                            text-align: center;
                            line-height: 37px;
                            margin-left: 20px;
                            cursor: pointer;
                        }

                        .lib_img {
                            width: 80px;
                            height: 80px;
                            cursor: pointer;
                            border-radius: 8px;
                        }

                        .lib_add {
                            width: 80px;
                            height: 80px;
                            background: #FFFFFF;
                            border-radius: 2px 2px 2px 2px;
                            border: 1px solid #E2E6ED;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            font-weight: 500;
                            font-size: 14px;
                            color: #999999;
                            cursor: pointer;

                            img {
                                width: 18px;
                                height: 18px;
                                margin-bottom: 10px;
                            }
                        }
                    }
                }

                .cl_list {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    justify-content: space-between;

                    .cl_item {
                        width: 47%;
                        margin-bottom: 20px;
                        display: flex;
                        align-items: center;

                        .cli_top {
                            width: 85px;
                            font-weight: bold;
                            font-size: 12px;
                            color: #252525;

                            span {
                                font-weight: 500;
                                font-size: 16px;
                                color: #FF0000;
                            }
                        }

                        .cli_bottom {
                            flex: 1;

                            // height: 25px;
                            .libi {
                                background: #2992FF !important;
                                color: #fff !important;
                            }

                            .lib_item {
                                width: fit-content;
                                padding: 6px 13px;
                                background: #F1F1F1;
                                border-radius: 1px 1px 1px 1px;
                                font-weight: 500;
                                font-size: 10px;
                                color: #020202;
                                margin-right: 10px;
                                margin-bottom: 10px;
                                user-select: none;
                                cursor: pointer;
                            }

                            // width: 100%;
                            // width: 255px;
                            .lib_btn {
                                width: 91px;
                                height: 37px;
                                border-radius: 8px 8px 8px 8px;
                                border: 1px solid #399AFF;
                                font-weight: bold;
                                font-size: 16px;
                                color: #2992FF;
                                text-align: center;
                                line-height: 37px;
                                margin-left: 20px;
                                cursor: pointer;
                            }

                            .lib_img {
                                width: 80px;
                                height: 80px;
                                cursor: pointer;
                                border-radius: 8px;
                            }

                            .lib_add {
                                width: 80px;
                                height: 80px;
                                background: #FFFFFF;
                                border-radius: 2px 2px 2px 2px;
                                border: 1px solid #E2E6ED;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                font-weight: 500;
                                font-size: 14px;
                                color: #999999;
                                cursor: pointer;

                                img {
                                    width: 18px;
                                    height: 18px;
                                    margin-bottom: 10px;
                                }
                            }
                        }
                    }
                }


                .cl_file {
                    width: 100%;
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    margin-top: 20px;

                    .clf_left {
                        font-weight: bold;
                        font-size: 16px;
                        color: #252525;
                    }

                    .clf_right {}
                }

                .cl_fileArr {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    flex-wrap: wrap;
                    margin-top: 20px;

                    .clf_item {
                        width: 150px;
                        display: flex;
                        align-items: center;

                        .lfi_icon {
                            width: 16px;
                            height: 16px;
                        }

                        .lfi_name {
                            font-weight: bold;
                            font-size: 16px;
                            color: #252525;
                            margin: 0 10px;
                        }

                        .lfi_del {
                            width: 16px;
                            height: 16px;
                            cursor: pointer;
                        }
                    }
                }
            }



            .cl_box::-webkit-scrollbar {
                // display: none;
            }

            .next {
                width: 125px;
                height: 33px;
                background: #2992FF;
                border-radius: 5px 5px 5px 5px;
                font-weight: 500;
                font-size: 13px;
                color: #FFFFFF;
                text-align: center;
                line-height: 33px;
                user-select: none;
                cursor: pointer;
            }
        }
    }

    .back {
        width: 100%;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        // margin-bottom: 10px;
        margin: 20px 0;
        cursor: pointer;
        box-sizing: border-box;
        padding: 0 30px;

        img {
            width: 14px;
            height: 14px;

        }
    }

    .content {
        width: 100%;
        height: 0;
        flex: 1;
        background-color: #fff;
        border-radius: 10px 10px 0 0;
        box-sizing: border-box;
        padding: 30px;
        display: flex;
        align-items: flex-start;
        // overflow-y: scroll;

        .c_left {
            height: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;

            .cl_title {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .cl_tab {
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 30px;

                .clt_tab {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-right: 50px;
                    cursor: pointer;

                    .ltt_top {
                        font-weight: 500;
                        font-size: 16px;
                        color: #000000;
                    }

                    .ltt_bottom {
                        width: 46px;
                        height: 2px;
                        background: #2992FF;
                        border-radius: 4px 4px 4px 4px;
                        margin-top: 10px;
                    }
                }
            }

            .cl_btn {
                width: 120px;
                height: 30px;
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                border: 1px solid #399AFF;
                font-weight: 500;
                font-size: 14px;
                color: #399AFF;
                text-align: center;
                line-height: 30px;
                margin-top: 20px;
                user-select: none;
                cursor: pointer;
            }

            .cl_box {
                width: 100%;
                flex: 1;
                height: 0;
                overflow-y: scroll;

                .cl_item {
                    width: 100%;
                    margin-bottom: 20px;

                    .cli_top {
                        font-weight: bold;
                        font-size: 16px;
                        color: #252525;
                        margin-bottom: 8px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        span {
                            font-weight: 500;
                            font-size: 16px;
                            color: #FF0000;
                        }
                    }

                    .cli_bottom {
                        width: 100%;

                        .libi {
                            background: linear-gradient(62deg, #194DFC 0%, #448DF8 100%) !important;
                            color: #fff !important;
                        }

                        .lib_item {
                            width: fit-content;
                            padding: 6px 13px;
                            background: #F1F1F1;
                            border-radius: 4px;
                            font-weight: bold;
                            font-size: 12px;
                            color: #020202;
                            margin-right: 10px;
                            margin-bottom: 10px;
                            user-select: none;
                            letter-spacing: 1px;
                            // cursor: not-allowed;
                            cursor: pointer;
                            position: relative;

                            img {
                                width: 15px;
                                height: 15px;
                                position: absolute;
                                right: -5px;
                                top: -5px;
                                background-color: #fff;
                                border-radius: 50%;
                            }
                        }

                        .lib_btn {
                            width: 91px;
                            height: 37px;
                            border-radius: 8px 8px 8px 8px;
                            border: 1px solid #399AFF;
                            font-weight: bold;
                            font-size: 16px;
                            color: #2992FF;
                            text-align: center;
                            line-height: 37px;
                            margin-left: 20px;
                            cursor: pointer;
                        }

                        .lib_img {
                            width: 80px;
                            height: 80px;
                            cursor: pointer;
                            border-radius: 8px;
                        }

                        .lib_add {
                            width: 80px;
                            height: 80px;
                            background: #FFFFFF;
                            border-radius: 2px 2px 2px 2px;
                            border: 1px solid #E2E6ED;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            font-weight: 500;
                            font-size: 14px;
                            color: #999999;
                            cursor: pointer;

                            img {
                                width: 18px;
                                height: 18px;
                                margin-bottom: 10px;
                            }
                        }
                    }
                }

                .cl_file {
                    width: 100%;
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    margin-top: 20px;

                    .clf_left {
                        font-weight: bold;
                        font-size: 16px;
                        color: #252525;
                    }

                    .clf_right {}
                }

                .cl_fileArr {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    flex-wrap: wrap;
                    margin-top: 20px;

                    .clf_item {
                        width: 150px;
                        display: flex;
                        align-items: center;

                        .lfi_icon {
                            width: 16px;
                            height: 16px;
                        }

                        .lfi_name {
                            font-weight: bold;
                            font-size: 16px;
                            color: #252525;
                            margin: 0 10px;
                        }

                        .lfi_del {
                            width: 16px;
                            height: 16px;
                            cursor: pointer;
                        }
                    }
                }
            }

            .cl_box::-webkit-scrollbar {
                // display: none;
            }


        }
    }

    .c_center {
        height: 100%;
        flex: 1;
        margin: 0 30px;
        box-sizing: border-box;
        padding: 0 30px;
        border-left: 1px solid#EAEAEA;
        border-right: 1px solid#EAEAEA;
        display: flex;
        flex-direction: column;


        .cc_title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: bold;
            font-size: 20px;
            color: #000000;
            margin-bottom: 20px;

            .cct_left {}

            .cct_right {
                width: 158px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                border: 1px solid #2992FF;
                font-weight: 500;
                font-size: 16px;
                color: #2992FF;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 6px;
                }
            }
        }

        .textareas {
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 1px;
            line-height: 25px;
        }

        // .cc_list::-webkit-scrollbar {
        //     display: none;
        // }

        .cc_list {
            width: 100%;
            height: 0;
            flex: 1;
            overflow-y: scroll;

            .ccl_item {
                width: 100%;

                .cli_tit {
                    font-weight: bold;
                    font-size: 16px;
                    color: #2992FF;
                }

                textarea {
                    width: 100%;
                    font-size: 16px;
                    margin-top: 14px;
                }
            }
        }
    }

    .c_right {
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .cr_title {
            width: 100%;
            text-align: left;
            font-weight: bold;
            font-size: 20px;
            color: #000000;
        }

        .chat {
            width: 100%;
            height: 0;
            flex: 1;
            box-sizing: border-box;
            // padding: 0 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            // margin-bottom: 10px;
            border-radius: 0 0 8px 8px;

            .ch_bottom::-webkit-scrollbar {
                display: none;
            }

            .ch_bottom {
                width: 100%;
                height: 0;
                flex: 1;
                overflow-y: scroll;
                margin-bottom: 15px;
                box-sizing: border-box;
                padding-bottom: 25px;

                .chb_item {
                    width: 100%;
                    margin-top: 20px;

                    .chb_left {
                        width: 100%;
                        display: flex;
                        align-items: flex-start;

                        .hbl_left {
                            width: 44px;
                            height: 44px;
                            border-radius: 4px;
                        }

                        .hbl_right {
                            // flex: 1;
                            margin-left: 20px;
                            width: fit-content;
                            // max-width: 500px;
                            background: #FAFAFA;
                            border-radius: 10px 10px 10px 10px;
                            box-sizing: border-box;
                            padding: 10px;

                            .blr_top {
                                font-weight: 500;
                                font-size: 16px;
                                color: #333333;
                                line-height: 32px;

                                .loading-container {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    height: 100%;
                                    // margin-top: 30rpx;
                                    box-sizing: border-box;
                                    padding: 10px;
                                    border-radius: 20px;
                                    margin-left: 16px;
                                    user-select: auto;
                                }

                                .dot {
                                    width: 10px;
                                    height: 10px;
                                    background-color: #333;
                                    border-radius: 50%;
                                    margin: 0 5px;
                                    animation: blink 1.4s infinite both;
                                    opacity: 0;
                                }

                                .dot:nth-child(1) {
                                    animation-delay: 0.2s;
                                }

                                .dot:nth-child(2) {
                                    animation-delay: 0.4s;
                                }

                                .dot:nth-child(3) {
                                    animation-delay: 0.6s;
                                }

                                @keyframes blink {
                                    0% {
                                        opacity: 0;
                                    }

                                    50% {
                                        opacity: 1;
                                    }

                                    100% {
                                        opacity: 0;
                                    }
                                }
                            }

                            .blr_bottom {
                                width: 100%;
                                display: flex;
                                align-items: center;
                                border-top: 1px solid#ececec;
                                margin-top: 10px;
                                padding-top: 10px;

                                .lrb_btn {
                                    font-weight: 500;
                                    font-size: 14px;
                                    color: #333333;
                                    margin-right: 30px;
                                    display: flex;
                                    align-items: center;
                                    cursor: pointer;

                                    img {
                                        width: 14px;
                                        height: 14px;
                                        margin-right: 5px;
                                    }
                                }
                            }
                        }
                    }

                    .chb_right {
                        display: flex;
                        flex-direction: column;
                        // align-items: flex-start;
                        // justify-content: flex-end;


                        .hbr_bottom {
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;

                            .hbr_text {
                                width: fit-content;
                                // max-width: 500px;
                                background: #2992FF;
                                border-radius: 10px 10px 10px 10px;
                                font-weight: 500;
                                font-size: 16px;
                                color: #FFFFFF;
                                line-height: 32px;
                                box-sizing: border-box;
                                padding: 10px;
                            }

                            .hbr_tx {
                                width: 44px;
                                height: 44px;
                                margin-left: 20px;
                                border-radius: 4px;
                            }
                        }

                    }
                }
            }

            .clear {
                width: 70px;
                height: 146px;
                background: #FFFFFF;
                border-radius: 20px 20px 20px 20px;
                border: 1px solid #E9EBF2;
                font-weight: 500;
                font-size: 14px;
                color: #333333;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                img {
                    width: 30px;
                    height: 30px;
                    margin-bottom: 10px;
                }
            }

            .o_bottom1 {
                flex: 1;
                width: 100%;
                min-height: 146px;
                background: #FFFFFF;
                box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.03);
                border-radius: 20px 20px 20px 20px;
                border: 1px solid #E9EBF2;
                box-sizing: border-box;
                padding: 20px;
                // margin-left: 20px;
                // margin-bottom: 20px;

                textarea {
                    width: 100%;
                    height: 56px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid rgba(188, 188, 188, 0.2);
                    font-size: 16px;
                }

                .ob_bottom1 {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    justify-content: space-between;
                    margin-top: 10px;

                    .obb_left {
                        cursor: pointer;

                        img {
                            width: 24px;
                            height: 24px;
                        }

                        // height: 30px;
                        // background: #F2F9FF;
                        // border-radius: 8px 8px 8px 8px;
                        // border: 1px solid #2992FF;
                        // font-weight: 500;
                        // font-size: 14px;
                        // color: #2992FF;
                        // text-align: center;
                        // line-height: 30px;
                    }

                    .obb_right {
                        display: flex;
                        align-items: center;

                        .bbr_1 {
                            width: 24px;
                            height: 24px;
                            margin-right: 30px;
                            cursor: pointer;
                        }

                        .bbr_2 {
                            width: 30px;
                            height: 30px;
                            cursor: pointer;

                        }
                    }
                }
            }
        }
    }

    .bottom {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #F0F0F0;
        padding: 20px 0;
        // margin-top: 20px;
        // margin-bottom: 20px;
        background-color: #fff;

        .bo_1 {
            width: 140px;
        }

        .btn {
            width: 164px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 8px 8px 8px 8px;
            border: 0px solid #399AFF;
            font-weight: bold;
            font-size: 16px;
            color: #399AFF;
            text-align: center;
            line-height: 40px;
            margin: 0 7px;
            cursor: pointer;
        }

        .btn1 {
            width: 164px;
            height: 40px;
            background: #399AFF;
            border-radius: 8px 8px 8px 8px;
            font-weight: bold;
            font-size: 16px;
            color: #FFFFFF;
            text-align: center;
            line-height: 40px;
            margin: 0 7px;
            cursor: pointer;
        }
    }
}
</style>